import React, { useMemo } from 'react';
import { isTrialEntitlement } from '@css-xp/entitlements-v2';
import { CloudProductDetailView } from '@css-xp/base/entitlement-utils';
import { NoData } from '@css-xp/ppc-common';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import {
  FetchSandboxParentQuery,
  LinkedDestinationEntitlement,
  EntitlementDetails,
} from '@css-xp/graphtypes/src/generated-types-new';

interface SandboxParentProps {
  entitlement: EntitlementDetails;
  parentDetails?: FetchSandboxParentQuery['entitlementDetails'] | LinkedDestinationEntitlement;
  loading?: boolean;
  isDesignIteration1Enabled?: boolean;
}

export const SandboxParent = ({
  entitlement,
  parentDetails,
  loading,
  isDesignIteration1Enabled,
}: SandboxParentProps) => {
  const isFreePlan = useMemo(() => (parentDetails?.edition ? parentDetails?.edition.includes('Free') : false), [
    parentDetails,
  ]);
  const isTrial = useMemo(() => !isFreePlan && isTrialEntitlement(entitlement, false), [isFreePlan, entitlement]);

  if (loading) {
    return (
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="60%" />
      </SkeletonLoaderWrapper>
    );
  }

  if (!parentDetails?.productId) {
    return <NoData />;
  }

  return (
    <CloudProductDetailView
      productId={parentDetails?.productId}
      entitlementNumber={parentDetails?.entitlementNumber ?? ''}
      productName={parentDetails?.productName}
      productLink={parentDetails?.entitlementNumber ?? ''}
      trial={isTrial}
      version={isDesignIteration1Enabled ? 2 : undefined}
      isEntitlementNumberCopyable={true}
    />
  );
};
